import { render, staticRenderFns } from "./FT.vue?vue&type=template&id=8faa18b0&scoped=true"
import script from "./FT.vue?vue&type=script&lang=js"
export * from "./FT.vue?vue&type=script&lang=js"
import style0 from "./FT.vue?vue&type=style&index=0&id=8faa18b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8faa18b0",
  null
  
)

export default component.exports